import React from 'react';
import OutstandingTab from './components/outstanding-tab';
import './style.scss';

const OutstandingList = () => {
	return <OutstandingTab />;
};

export default OutstandingList;
